// 定义静态路由，动态路由(后端接口返回)及处理在 `utils/routesFilter.js` 中

export default [
    {
        path: '/static/onlineservice/hotlineSetting',
        name: 'service-setting',
        component: () => import('views/modules/setting/onlineservice/line-setting.vue'),
        meta: {
            parent: '/setting',
            icon: 'el-icon-document',
            title: '客服热线设置',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    },
];
